import React, { createContext, useEffect, useState } from 'react';

import CURRENT_USER from '../../GraphQl/Queries/CURRENT_USER';
import { useLazyQuery, useMutation, useQuery } from 'react-apollo';
import TASKS_CONNECTION from '../../GraphQl/Queries/TASKS';
import CREATE_TASK from '../../GraphQl/Mutations/CREATE_TASK';
import GET_TASK from '../../GraphQl/Queries/GET_TASK';
import UPDATE_TASK from '../../GraphQl/Mutations/UPDATE_TASK';
import UPDATE_COMMENT from '../../GraphQl/Mutations/UPDATE_COMMENT';
import CREATE_COMMENT from '../../GraphQl/Mutations/CREATE_COMMENT';
import GET_HISTORIES from '../../GraphQl/Queries/GET_HISTORIES';
import GET_TASK_BY_IDS from '../../GraphQl/Queries/GET_TASK_BY_IDS';
import GET_TASK_DATE from '../../GraphQl/Queries/GET_TASK_DATE';
import CAMPAIGN_ORDER from '../../GraphQl/Queries/CAMPAIGN_ORDER';
import TEAMS from '../../GraphQl/Queries/TEAMS';
import CREATE_TEAM from '../../GraphQl/Mutations/CREATE_TEAM';
import UPDATE_TEAM from '../../GraphQl/Mutations/UPDATE_TEAM';
import DELETE_TEAM from '../../GraphQl/Mutations/DELETE_TEAM';

const TaskContext = createContext({});

export const TaskProvider = (props) => {
  const { children } = props;

  const [task, setTask] = useState([]);
  const [activity, setActivity] = useState([]);
  const [overdueTasks, setOverdueTasks] = useState([]);
  const [selectedTask, setSelectedTask] = useState(null);
  const [showMyTasks, setShowMyTasks] = useState(true);
  const [viewChanged, setViewChanged] = useState(false);
  const [linkedCampaign, setLinkedCampaign] = useState(null);
  const [taskBoardPagination, setTaskBoardPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [unassignedTaskPagination, setUnassignedTaskPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [activityPagination, setActivityPagination] = useState({
    current: 1,
    pageSize: 4,
    total: 0,
  });
  const [isKanban, setIsKanban] = useState(false);

  // TODO: This should be move on the top level of the application
  const {
    data: { currentUser },
  } = useQuery(CURRENT_USER);

  const [fetchTasksPaginated, { data: tasksConnectionData, loading: tasksLoading }] = useLazyQuery(
    TASKS_CONNECTION,
    {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    }
  );

  const [fetchAllTasks, { data: allTasksData, loading: allTasksLoading }] = useLazyQuery(
    TASKS_CONNECTION,
    {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    }
  );

  useEffect(() => {
    if (tasksConnectionData && tasksConnectionData.tasksConnection) {
      setTask(tasksConnectionData.tasksConnection.edges.map((edge) => edge.node));
      setTaskBoardPagination({
        ...taskBoardPagination,
        total: tasksConnectionData.full.aggregate.count,
      });
      setUnassignedTaskPagination({
        ...unassignedTaskPagination,
        total: tasksConnectionData.full.aggregate.count,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tasksConnectionData]);

  const [
    fetchTask,
    { data: taskData, loading: taskLoading, error: taskError, refetch: refetchTask },
  ] = useLazyQuery(GET_TASK, {
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-first',
  });

  // Mutations
  const [createTask, { loading: createTaskLoading }] = useMutation(CREATE_TASK);
  const [updateTask, { loading: updateTaskLoading }] = useMutation(UPDATE_TASK);
  const [createComment, { loading: createCommentLoading }] = useMutation(CREATE_COMMENT);
  const [updateComment, { loading: updateCommentLoading }] = useMutation(UPDATE_COMMENT);

  const [fetchHistories, { data: dataHistories, loading: loadingHistories }] = useLazyQuery(
    GET_HISTORIES,
    {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    }
  );

  const [fetchTasksOverdue, { data: tasksOverdueDate, loading: tasksOverdueLoading }] =
    useLazyQuery(GET_TASK_DATE, {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    });

  const [fetchTaskByIds, { data: taskByIdsData, loading: taskByIdsLoading }] = useLazyQuery(
    GET_TASK_BY_IDS,
    {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    }
  );

  const [fetchCampaignForTask, { data: linkedCampaignData, loading: linkedCampaignLoading }] = useLazyQuery(
    CAMPAIGN_ORDER,
    {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    }
  );

  // Team operations
  const [fetchTeams, { data: teamsData, loading: teamsLoading }] = useLazyQuery(
    TEAMS,
    {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    }
  );
  const [fetchOrgTeams, { data: orgTeamsData, loading: orgTeamsLoading }] = useLazyQuery(
    TEAMS,
    {
      fetchPolicy: 'cache-and-network',
      nextFetchPolicy: 'cache-first',
    }
  );
  const [createTeam, { loading: createTeamLoading }] = useMutation(CREATE_TEAM);
  const [updateTeam, { loading: updateTeamLoading }] = useMutation(UPDATE_TEAM);
  const [deleteTeam, { loading: deleteTeamLoading }] = useMutation(DELETE_TEAM);

  useEffect(() => {
    if (taskByIdsData && taskByIdsData.getTaskByIds) {
      const activities = taskByIdsData.getTaskByIds.edges.map((edge) => edge.node);
      setActivity(activities);
      setActivityPagination((prev) => ({
        ...prev,
        total: taskByIdsData.full.aggregate.count,
      }));
    }
  }, [taskByIdsData]);

  useEffect(() => {
    if (tasksOverdueDate && tasksOverdueDate.getTaskDate) {
      const overdueDate = tasksOverdueDate.getTaskDate.edges.map((edge) => edge.node);
      setOverdueTasks(overdueDate);
    }
  }, [tasksOverdueDate]);

  useEffect(() => {
    if (linkedCampaignData && linkedCampaignData.campaignOrders && linkedCampaignData.campaignOrders.length > 0) {
      setLinkedCampaign(linkedCampaignData.campaignOrders[0]);
    }
  }, [linkedCampaignData]);

  return (
    <TaskContext.Provider
      value={{
        currentUser,
        fetchTasksPaginated,
        fetchAllTasks,
        allTasksData,
        allTasksLoading,
        tasksConnectionData,
        tasksLoading,
        task,
        taskBoardPagination,
        setTaskBoardPagination,
        unassignedTaskPagination,
        setUnassignedTaskPagination,
        createTask,
        createTaskLoading,
        selectedTask,
        setSelectedTask,
        fetchTask,
        currentTask: (taskData && taskData.task) || null,
        taskLoading,
        taskError,
        updateTask,
        updateTaskLoading,
        createComment,
        createCommentLoading,
        updateComment,
        updateCommentLoading,
        refetchTask,
        histories: (dataHistories && dataHistories.historyLogs) || [],
        loadingHistories,
        fetchHistories,
        setActivityPagination,
        activityPagination,
        fetchTaskByIds,
        taskByIdsData,
        taskByIdsLoading,
        activity,
        setActivity,
        tasksOverdueLoading,
        fetchTasksOverdue,
        overdueTasks,
        setOverdueTasks,
        showMyTasks,
        setShowMyTasks,
        isKanban,
        setIsKanban,
        viewChanged,
        setViewChanged,
        setTask,
        fetchCampaignForTask,
        linkedCampaign,
        linkedCampaignLoading,
        setLinkedCampaign,
        fetchTeams,
        teamsData,
        teamsLoading,
        fetchOrgTeams,
        orgTeamsData,
        orgTeamsLoading,
        createTeam,
        createTeamLoading,
        updateTeam,
        updateTeamLoading,
        deleteTeam,
        deleteTeamLoading,
      }}
    >
      {children}
    </TaskContext.Provider>
  );
};

export default TaskContext;
